//src/components/admin/pagebuilder/pageModal/SeoModal

import React, { useState } from "react";

export default function SeoModal({ seo, onSave, onClose }) {
  const [form, setForm] = useState(seo || {});

  const update = (k, v) =>
    setForm((p) => ({ ...p, [k]: v }));

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex justify-center items-center">
      <div className="bg-white w-full max-w-xl p-6 rounded">
        <h2 className="text-xl font-bold mb-4">SEO da Página</h2>

        <input
          className="input mb-2"
          placeholder="Título (title)"
          value={form.title || ""}
          onChange={(e) => update("title", e.target.value)}
        />

        <textarea
          className="input mb-2"
          placeholder="Descrição (meta description)"
          value={form.description || ""}
          onChange={(e) => update("description", e.target.value)}
        />

        <input
          className="input mb-2"
          placeholder="Palavras-chave"
          value={form.keywords || ""}
          onChange={(e) => update("keywords", e.target.value)}
        />

        <hr className="my-4" />

        <input
          className="input mb-2"
          placeholder="OG Title"
          value={form.ogTitle || ""}
          onChange={(e) => update("ogTitle", e.target.value)}
        />

        <textarea
          className="input mb-2"
          placeholder="OG Description"
          value={form.ogDescription || ""}
          onChange={(e) => update("ogDescription", e.target.value)}
        />

        <input
          className="input mb-2"
          placeholder="OG Image URL"
          value={form.ogImage || ""}
          onChange={(e) => update("ogImage", e.target.value)}
        />

        <div className="flex justify-end gap-3 mt-6">
          <button onClick={onClose}>Cancelar</button>
          <button
            className="btn-primary"
            onClick={() => onSave(form)}
          >
            Salvar SEO
          </button>
        </div>
      </div>
    </div>
  );
}
